import type { TGroup } from '../pages/overview';

export type OptimisticAction =
	| {
			type: 'ADD_CARRIER_TO_GROUP';
			carrier: {
				id: number;
				title: string;
				subtitle: string;
			};
			groupId: number;
	  }
	| { type: 'REMOVE_CARRIER_FROM_GROUP'; carrierId: number; groupId: number }
	| { type: 'REMOVE_GROUP'; groupId: number };

const optimisticReducer = (
	state: TGroup[],
	action: OptimisticAction,
): TGroup[] => {
	switch (action.type) {
		case 'ADD_CARRIER_TO_GROUP': {
			const targetGroupIdx = state.findIndex(
				(group) => group.groupId === action.groupId,
			);
			if (targetGroupIdx === -1) {
				return state;
			}

			const result = [...state];
			const targetGroup = result[targetGroupIdx];

			// Check if carrier already exists
			if (
				targetGroup.carriers?.some(
					(carrier) => carrier.organizationId === action.carrier.id,
				)
			) {
				return state;
			}

			result[targetGroupIdx] = {
				...targetGroup,
				carriers: [
					...(targetGroup.carriers ?? []),
					{
						organizationId: action.carrier.id,
						organizationName: action.carrier.title,
						email: action.carrier.subtitle,
						isPending: true,
					},
				],
			};

			return result;
		}

		case 'REMOVE_CARRIER_FROM_GROUP': {
			const groupIdx = state.findIndex(
				(group) => group.groupId === action.groupId,
			);
			if (groupIdx === -1) {
				return state;
			}

			const result = [...state];
			const group = result[groupIdx];

			const carrierIdx = (group.carriers ?? []).findIndex(
				(carrier) => carrier.organizationId === action.carrierId,
			);
			if (carrierIdx === -1) {
				return state;
			}
			const carriers = [...(group.carriers ?? [])];
			carriers[carrierIdx] = {
				...carriers[carrierIdx],
				isPending: true,
			};

			result[groupIdx] = {
				...group,
				carriers,
			};

			return result;
		}

		case 'REMOVE_GROUP': {
			const groupIdx = state.findIndex(
				(group) => group.groupId === action.groupId,
			);
			if (groupIdx === -1) {
				return state;
			}

			const result = [...state];
			const group = result[groupIdx];

			result[groupIdx] = {
				...group,
				isPending: true,
			};

			return result;
		}

		default:
			return state;
	}
};

export default optimisticReducer;
